<template>
     <div class="bgiOver">
      <div class="over over1">
        <div class="timeout01">{{title}}</div>
        <div class="timeout02" v-html="content"></div>
        <div class="okButton" @click="okHandler()" v-show="!isConfirm">{{okButtonTxt}}</div>
        <div class="cancelButton" @click="confirmCancelHandler()" v-show="isConfirm">{{cancelButtonTxt}}</div>
        <div class="confirmButton" @click="ConfirmOK()" v-show="isConfirm">{{okButtonTxt}}</div>
        <!-- <div class="sOver1  animated bounceInDown"></div> -->
      </div>
    </div>
</template>
<script>
import MediaUtils from "@/utils/MediaUtils";

export default {
    name:"leapDialog",
    props:{
        title:"",
        content:"",
        ok:true,
        cancel:true,
        cancelButtonTxt:"",
        okButtonTxt:"",
        isConfirm:true,
    },

    async mounted() {
      if (MediaUtils.isMobileBrowser()) {
        let overs = document.querySelectorAll(".over");
        overs.forEach(over => {
            over.style.scale = 0.6;
        })
      }
    },

    methods:{
        confirmCancelHandler(){
            this.$emit('onCancel')
        },
        ConfirmOK(){
            this.$emit('onConfirm')
        },
        okHandler(){
          this.$emit('onOK')
        }
    }
}
</script>
<style lang="scss" scoped>
.bgiOver {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;
}
.okButton{
  background: url("~@/assets/images/OKConfirmBtn.png") no-repeat 1px 2px;
  width:141px;
  height:71px;
  position: absolute;
  top: 340px;
  left: 220px;
  line-height: 58px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
}

.over {
  width: 725px;
  height: 467px;
  position: absolute;
  background: url("~@/assets/images/PopUp_bg.png") no-repeat 1px 2px;
}
.over1 {
  width: 564px;
  height: 458px;
}
.timeout01 {
  width: 184px;
  height: 58px;
  position: absolute;
  top: 21px;
  left: 191px;
  z-index: 1;
  text-align: center;
  line-height: 58px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}
.timeout02 {
  width: 500px;
  height: 200px;
  position: absolute;
  top: 100px;
  left: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  font-size: 19px;
  padding-top: 50px;
  font-weight: 700;
}
.cancelButton {
  width: 135px;
  height: 59px;
  position: absolute;
  top: 354px;
  left: 69px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  font-weight: 700;
  background: url("~@/assets/images/CancelBtn.png") no-repeat 1px 2px;
}
.confirmButton {
  width: 136px;
  height: 59px;
  position: absolute;
  top: 354px;
  left: 370px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 23px;
  cursor: pointer;
  font-weight: 700;
  background: url("~@/assets/images/OKBtn.png") no-repeat 1px 2px;
}

</style>


// WEBPACK FOOTER //
// src/components/LeapPopup.vue